import { Component,  Input, EventEmitter, Output, ViewChild, ElementRef, SimpleChanges, OnChanges } from '@angular/core';
import { JoiComment } from 'globals/store/tasks.data';
import { publicHelpers } from './../../helpers/public-helpers';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { WFWorker } from 'globals/store/workforce.data';
import { PhotoData } from 'globals/store/user.data';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { PhotoComponent } from 'src/app/components/photo';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { GreyWrapperComponent } from 'src/app/components/wrappers/grey-wrapper.component';

@Component({
    selector: 'quick-note',
    template: `
<grey-wrapper>
  <div class="header">
    <photo [size]="24" [data]="user"></photo>
    <ng-content></ng-content>
    <div style="flex:1;"></div>
    <div #dotMenuHolder class="dot-menu-holder" *ngIf="!readOnly" [matMenuTriggerFor]="dotMenu">
      <icon class="dots" matIcon="more_vert"></icon>
    </div>
    <mat-menu #dotMenu="matMenu" xPosition="before">
      <button mat-menu-item *ngFor="let option of threeDotOptions" 
        (click)="threeDotSelection(option.id)" >{{ option.name }}</button>
    </mat-menu>
  </div>
  <div class="editing-wrapper smooth">
    <joi-input #noteInput class="description" [disabled]="readOnly || !editingMode" [italicPlaceholder]="true" [(model)]="currentNote.note" [type]="'textarea'" [returnable]="true" [placeholder]="'         '"></joi-input>
    <div class="editing-buttons smooth" [ngClass]="{ visible: editingMode }" >
      <div style="flex:1;"></div>
      <button mat-button *ngIf="!!editingMode" (click)="cancelEditNote()">CANCEL</button>
      <button mat-button *ngIf="!!editingMode" color="primary" [disabled]="noteIsEmpty || noteHasChanged" class="inner-primary" (click)="saveNote()">SAVE</button>
    </div>
  </div>
</grey-wrapper>
`,
    styles: [`
    .header { display: flex; }
    .editing-wrapper { display: flex; flex-direction: column; }
    .editing-buttons { display: flex; margin-top: 0px; height: 0px; overflow: hidden; }
    .editing-buttons.visible { height: 30px; margin-top: 15px; }
    joi-input { margin-bottom: 0px; }
    ::ng-deep quick-note .wrapper .grey-wrapper { padding: 10px 15px !important; }
    .dot-menu-holder { color: rgba(0,0,0,0.4); cursor: pointer; margin-right: -10px; }
    .mat-button.mat-primary.inner-primary { margin-right: 0px !important; }
`],
    standalone: true,
    imports: [JoiInputComponent, CommonModule, MatMenuModule, PhotoComponent,IconComponent, GreyWrapperComponent]
})
export class QuickNoteComponent implements OnChanges {
  @Input() readOnly = true
  @Input() note: JoiComment
  @Input() user: PhotoData | WFWorker  

  currentNote = { note: '' }
  editingMode = false
  threeDotOptions: { name: string, id: DotsOption }[] = [{ name: 'Edit', id: 'edit' }, { name: 'Delete', id: 'delete' }]
  publicHelpers = publicHelpers
  noteHasChanged = false
  noteIsEmpty = false

  @ViewChild('dotMenuHolder') dotMenu: ElementRef
  @ViewChild('noteInput') noteInput: JoiInputComponent
  @Output() delete: EventEmitter<void> = new EventEmitter()
  @Output() save: EventEmitter<string> = new EventEmitter()

  constructor(private dialog: MatDialog) {}

  cancelEditNote(keepNote = false) {
    this.editingMode = false
    this.noteIsEmpty = false
    this.noteHasChanged = false
    if (!keepNote) this.currentNote.note = this.note.content
  }

  /* checkNote() {
    setTimeout(() => {
      console.log({ note: this.currentNote.note, content: this.note.content })
      this.noteHasChanged = this.currentNote.note !== this.note.content
      this.noteIsEmpty = !this.currentNote.note 
      console.log("Checking note... ", { noteHasChanged: this.noteHasChanged, noteIsEmpty: this.noteIsEmpty })
    }, 0)
  } */

  saveNote() {
    const noteHasChanged = this.currentNote.note !== this.note.content
    console.log(`Note has changed: ${ noteHasChanged }`)
    if (noteHasChanged) this.save.emit(this.currentNote.note)
    this.cancelEditNote(true)
  }

  async threeDotSelection(choiceId: DotsOption) {
    switch (choiceId) {
      case 'edit':
        this.editingMode = true
        setTimeout(() => this.noteInput.manualFocus(), 0)
        break
      case 'delete': {
        this.deleteNote()
        break
      }
    }
  }

  setNote(note: JoiComment) {
    if(!this.editingMode) this.currentNote.note = note.content
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.note?.currentValue) {
      this.setNote(changes.note.currentValue)
    }
  }

  async deleteNote() {
    // Confirmation is nested in the status-wrapper component
    const el: HTMLElement = this.dotMenu.nativeElement
    const rect = el.getBoundingClientRect()
    // console.log({ rect, el })
    const data: ConfirmDeleteData = {
      title: 'Remove this note',
      deleteButtonText: 'REMOVE',
      rect,
      bottomOffset: -10,
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.delete.emit()
  }

}

type DotsOption = 'edit' | 'delete'